module.exports = __webpack_public_path__ + "img/td-8.a9762508.jpg";